/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateViewResponse
 */
export interface CreateViewResponse {
  /**
   *
   * @type {string}
   * @memberof CreateViewResponse
   */
  savedViewId: string;
}

/**
 * Check if a given object implements the CreateViewResponse interface.
 */
export function instanceOfCreateViewResponse(
  value: object,
): value is CreateViewResponse {
  if (!("savedViewId" in value) || value["savedViewId"] === undefined)
    return false;
  return true;
}

export function CreateViewResponseFromJSON(json: any): CreateViewResponse {
  return CreateViewResponseFromJSONTyped(json, false);
}

export function CreateViewResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateViewResponse {
  if (json == null) {
    return json;
  }
  return {
    savedViewId: json["savedViewId"],
  };
}

export function CreateViewResponseToJSON(json: any): CreateViewResponse {
  return CreateViewResponseToJSONTyped(json, false);
}

export function CreateViewResponseToJSONTyped(
  value?: CreateViewResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    savedViewId: value["savedViewId"],
  };
}
